var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"product-options-input",staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateSelf($event.target.value)},"keyup":function($event){return _vm.onKeyup($event.target.value)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ccf1ee","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/SearchInput.vue
// module id = 962
// module chunks = 0